import { Visibility, VisibilityOff } from '@mui/icons-material';
import styled from 'styled-components';

import React, { useRef, useState } from 'react';

const InputWrapper = styled.div`
    position: relative;
    width: 100%;
`;

const InputField = styled.input`
    padding: 0.625rem 1.25rem;
    width: 100%;
    padding-right: 3rem;

    &:focus {
        background-color: #fff !important;
        border:1px solid #ff5f39;
    }
`;

const EyeButton = styled.button`
    position: absolute;
    top: 50%;
    right: 0.75rem;
    transform: translateY(-50%);
    background: none;
    border: none;
    cursor: pointer;
    color: #999;

    &:focus {
        outline: none;
    }
`;

const PasswordInput = ({
    value,
    onChange,
    name,
    placeholder,
    onFocus,
    onBlur,
    autoFocus = false,
    isError = false,
}) => {
    const [showPassword, setShowPassword] = useState(false);

    const togglePasswordVisibility = () => {
        setShowPassword((prev) => !prev);
    };

    return (
        <InputWrapper>
            <InputField
                type={showPassword ? 'text' : 'password'}
                placeholder={placeholder}
                value={value}
                onChange={onChange}
                name={name}
                required={true}
                onFocus={onFocus}
                onBlur={onBlur}
                autoFocus={autoFocus}
                className={`common-input ${isError ? 'error-field' : ''}`}
            />
            <EyeButton type="button" onClick={togglePasswordVisibility}>
                {showPassword ? <VisibilityOff /> : <Visibility />}
            </EyeButton>
        </InputWrapper>
    );
};

export default PasswordInput;
